import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { LenderUserBorrowerPreference } from 'ng2-app/models/dto/lender-user-borrower-preference.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LenderUserBorrowerPreferenceService {

  constructor(private http: ApiHttpClient) { }

  put(borrowerId: number, favorite: boolean): Observable<LenderUserBorrowerPreference> {
    return this.http.put<LenderUserBorrowerPreference>(`${environment.API_URL}/lender-user/borrower/preference`, { borrowerId, favorite });
  }
}
